import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
export const usePopover = t0 => {
  const $ = _c(7);
  const {
    initialOpen: t1
  } = t0;
  const initialOpen = t1 === undefined ? false : t1;
  const [open, setOpen] = useState(initialOpen);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setOpen(false);
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const onClosePopover = t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setOpen(true);
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const onOpenPopover = t3;
  let t4;
  if ($[2] !== open) {
    t4 = {
      animate: "bottom" as const,
      open,
      onClose: onClosePopover,
      position: "end" as const,
      gapHorizontal: "-24px",
      gapVertical: "-16px"
    };
    $[2] = open;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== open || $[5] !== t4) {
    t5 = {
      open,
      onOpenPopover,
      onClosePopover,
      popoverProperties: t4
    };
    $[4] = open;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};